
export const taskActions = {
    changeSelectedTask
};

function changeSelectedTask(task) {
    return { type: 'changeSelectedTask', task };
}
